import {
  Row,
  Col,
  Dropdown,
  DropdownToggle,
  DropdownMenu,
  DropdownItem,
  Input,
  Button,
  Alert,
  UncontrolledTooltip,
} from "reactstrap";
import { Link } from "react-router-dom";
import classnames from "classnames";
import { Utils } from "helpers/utils";
import { useRedux } from "hooks";
import { createSelector } from "reselect";
import { MemberRole, WpPostInfo, WpPostInfoTag, WpSliceData, WpStatus, WpTitle } from "../../../redux/workplace/wpTypes";
import { setActivePostId2, setFlag, changePostStatus, setUnread } from "../../../redux/workplace/wpActions";
import { changeSelectedChat } from "../../../redux/actions";
import { APIClient } from "../../../api/apiCore";
import * as urls from "../../../api/urls"
import { useState } from "react";
import LoadingIconWithText from "components/LoadingIconWithText";
import { Tooltip } from "react-tooltip";


interface WorkplaceHeadProps {
  onOpenPostDetails: () => any;
  onTagClick: (tagId: number) => void;
  onSnoozeClick: (sender: any, postId: string) => void;
}

const WorkplaceHead = ({
  onOpenPostDetails, onTagClick, onSnoozeClick
}: WorkplaceHeadProps) => {
  const { dispatch, useAppSelector } = useRedux();

  const storeData = createSelector(
    (state: any) => state.WpSlice,
    (state: any) => state.Layout,
    (wp: WpSliceData, layout) => ({
      activePostId: wp.activePostInfo.postId,
      activePostTitle: wp.activePostInfo.title,
      activePostAbbr: wp.activePostInfo.abbrName,
      activePostAbbrBack: wp.activePostInfo.abbrBack,
      activePostAbbrFore: wp.activePostInfo.abbrFore,
      activePostIcon: wp.activePostInfo.icon,
      activePostTags: wp.activePostInfo.tags,
      activePostFlag: wp.activePostInfo.flag,
      activePostSnooze: wp.activePostInfo.snooze,
      activePostIsYours: wp.activePostInfo.isYourPost,
      activePostStatus: wp.activePostInfo.status,
      activePostCanChangeStatus: wp.activePostInfo.canChangeStatus,
      activePostYouIsMember: wp.activePostInfo.youIsMember,
      activePostCanDel: wp.activePostInfo.canDeletePost,
      isEmbChatOnly: wp.isEmbChatOnly,
      viewPortSize: layout.viewPortSize,
      isInFrame: layout.isInFrame,
    })
  );
  const {
    activePostId, activePostIcon, activePostTitle, activePostFlag, activePostSnooze, activePostAbbr
    , activePostAbbrBack, activePostAbbrFore, activePostTags, activePostIsYours, activePostStatus, activePostCanChangeStatus, activePostYouIsMember, activePostCanDel
    , viewPortSize, isInFrame, isEmbChatOnly
  } = useAppSelector(storeData);

  const isDark = Utils.IsDarkTheme();

  const onCloseConversation = () => {
    dispatch(setActivePostId2(null, null, null, null, null, "Close conversation"));
  }

  const onClickPostInfo = () => {
    try {
      const api = new APIClient
      api.fnPostForm(urls.WP_LOAD_POST_INFO_MEMBER, { postId: activePostId })
        .then(rs => {
          // let ar: string[] = [];
          let table: string = `<table style="width:100%">`;
          rs.forEach((element: any) => {
            // ar.push(element.displayName2 + ' (Role:' + element.memberRoleText + ')');
            table += `<tr><td align="right">${element.displayName2}</td><td>&nbsp;&nbsp;&nbsp;</td><td align="left">${element.memberRoleText}</td></tr>`;
          });
          table += `</table>`;
          // alert(ar.join('<br/>'));
          alert(table);
          console.log(rs);
        })
        .catch(e2 => Utils.HandleException(e2, true));

    } catch (e) {
      Utils.HandleException(e, true);
    }
  }

  const [isDeletingPost, setIsDeletingPost] = useState<boolean>(false);
  const onDeletePost = (postId: string) => {
    try {
      Utils.SweetConfirm('คุณต้องการลบโพสที่เลือก เป็นการถาวร ใช่หรือไม่?')
        .then(rs => {
          if (rs.isConfirmed) {
            setIsDeletingPost(true);
            const api = new APIClient();
            api.fnPostForm(urls.WP_DELETE_POST, { fromDeviceId: Utils.GetDeviceId(), postId: postId })
              .then(rs => {
                setIsDeletingPost(false);
                console.log('rs:', rs);
              })
              .catch(e2 => {
                setIsDeletingPost(false);
                Utils.HandleException(e2, true);
              });
          }
        })
        .catch(e2 => Utils.HandleException(e2, true));
    } catch (e) {
      Utils.HandleException(e, true);
    }
  }

  const onToggleFlag = async (postId: string) => {
    try {
      if (postId != "") {
        const api = new APIClient();
        api.fnPostForm(urls.WP_TOGGLE_FLAG, { postId: postId })
          .then(rs => {
            dispatch(setFlag(postId, rs.flag));
          })
          .catch(e2 => Utils.HandleException(e2, true));
      }
    } catch (e) {
      Utils.HandleException(e, true);
    }
  }

  const onChangePostStatus = async (postId: string, changeTo: WpStatus) => {
    try {
      if (postId) {
        const changeToText = activePostStatus === WpStatus.Open ? Utils.GetWpStatus(WpStatus.Close) : Utils.GetWpStatus(WpStatus.Open);
        const confirm = `<h3>ยืนยันเปลี่ยนสถานะโพสเป็น <span class="text-danger">${changeToText}</span> ใช่หรือไม่</h3>`;
        Utils.SweetConfirm(confirm)
          .then(rs => {
            if (rs.isConfirmed) {
              const api = new APIClient();
              const parm = {
                fromDeviceId: Utils.GetDeviceId(),
                postId: postId,
                changeTo: changeTo
              };
              console.log('change post status:', parm);
              api.fnPostForm(urls.WP_CHANG_POST_STATUS, parm)
                .then(rs2 => {
                  //dispatch(changePostStatus(postId, changeTo)); -> notify via signal R already
                })
                .catch(e2 => Utils.HandleException(e2, true));
            }
          })
          .catch(e2 => Utils.HandleException(e2, true));
      }
    } catch (e) {
      Utils.HandleException(e, true);
    }

  }

  const [tipPostShareShow, setTipPostShareShow] = useState<boolean>(false);

  const onSharePost = (postId: string) => {
    try {
      const deviceOs = Utils.GetDeviceOS();
      const isWindows = deviceOs === "Windows";
      const baseUrl = Utils.GetBaseUrl();
      const URL = `${baseUrl}/redirect?wpc=${postId}`;
      navigator.clipboard.writeText(URL); // always copy to clipboard
      if (isWindows) {
        // navigator.clipboard.writeText(URL);
        setTipPostShareShow(true);
        setTimeout(() => { setTipPostShareShow(false); }, 1000);
      } else {
        if (navigator.canShare && navigator.canShare({ url: URL })) {
          navigator.share({
            url: URL,
            title: "Link หัวข้อโพส",
            text: "",
            //files: [file], // Share the actual image file
          });
        } else {
          // navigator.clipboard.writeText(URL);
          setTipPostShareShow(true);
          setTimeout(() => { setTipPostShareShow(false); }, 1000);
        }
      }

    } catch (e) {

    }
  }

  const onMarkUnread = (postId: string) => {
    try {
      const api = new APIClient();
      api.fnPostForm(urls.WP_MARK_UNREAD, { postIdParent: postId })
        .then(rs => {
          dispatch(setActivePostId2(null, null, null, null, null, "Mark as unread"));
          dispatch(changeSelectedChat(null));
          dispatch(setUnread(postId, 1));
        })
        .catch(e2 => {
          Utils.HandleException(e2, true);
        });
    } catch (e) {
      Utils.HandleException(e, true);
    }
  }

  return (
    <>
      <div style={{ display: "flex", alignItems: "center", overflow: "hidden" }}>

        {/* Div 1: Icon (Fixed Width) */}
        <div style={{ width: 40, padding: 0, }}>
          {/* back icon */}
          {!isEmbChatOnly && (
            <div className="flex-shrink-0 d-block d-md-none me-2 ">
              <Link
                to="#"
                onClick={onCloseConversation}
                className={classnames("user-chat-remove text-muted font-size-24 p-2", { "user-chat-remove-dark": isDark })}
              >
                <i id="uh-back" className="bx bx-chevron-left align-middle"></i>
              </Link>
            </div>
          )}
          {/* post logo */}
          <div className={classnames("avatar-sm align-self-center me-2 ", { "hide-sm-bellow": !isEmbChatOnly })}>
            <span className={classnames("avatar-title-nocolor", "rounded-circle", "text-uppercase", "text-white",)} >
              {
                (activePostIcon !== null && activePostIcon != "") ? (
                  <span className={"avatar-wp-icon rounded-circle"} style={{ marginLeft: "0px", backgroundColor: "transparent !important" }}>{activePostIcon}</span>
                ) : (activePostAbbr.includes('/')) ? (
                  <><img src={activePostAbbr} className="img-fluid rounded-circle img-fit img-xs" /></>
                ) : (
                  <>
                    <span className={"avatar-wp rounded-circle text-uppercase"} style={{ backgroundColor: activePostAbbrBack, color: activePostAbbrFore }} >
                      {activePostAbbr}
                    </span>
                  </>
                )
              }
            </span>
          </div>
        </div>

        {/* Middle Section (Title & Command) */}
        <div style={{ display: "flex", flexDirection: "column", flex: 1, overflow: "hidden" }}>

          {/* Upper Row: Title & Command */}
          <div style={{ display: "flex", alignItems: "center", }}>

            {/* Div 2: Title (Truncated) */}
            <div
              style={{
                flex: 1,
                padding: 0,
                whiteSpace: "nowrap",
                overflow: "hidden",
                textOverflow: "ellipsis",
                textAlign: "center"
              }}
            >
              {/* header title */}
              <div className="ps-2" style={{ textAlign: "left" }}>
                <h6 className="text-truncate mb-0 font-size-18">
                  <Link
                    to="#"
                    onClick={() => { onClickPostInfo() }}
                    className="user-profile-show text-reset"
                    data-postid={activePostId}
                  >
                    {activePostTitle}
                  </Link>
                </h6>
              </div>
            </div>

            {/* Div 3: Command (Align Right) */}
            <div style={{ padding: 0, textAlign: "right" }}>
              <Tooltip id="tipPostShare" isOpen={tipPostShareShow} />
              {/* header button */}
              <ul className="list-inline user-chat-nav text-end mb-0" style={{ display: "flex", gap: "2px" }}>

                <li className="list-inline-item  hand" title="มาร์คว่ายังไม่อ่าน" onClick={(e) => onMarkUnread(activePostId ?? "")}>
                  {/* <i className="fa fa-envelope-open-o"></i> */}
                  <i className="fas fa-book-open"></i>
                  {/* <i className="fa fa-envelope-o"></i> */}
                </li>

                <li className="list-inline-item hand " title="แชร์โพส" onClick={() => onSharePost(activePostId ?? "")} data-tooltip-id="tipPostShare" data-tooltip-content="คัดลอกลิ้งของโพสแล้ว"><i className="fa fa-share-alt"></i></li>

                <li className="list-inline-item  " title="ตั้งเตือน" onClick={(e) => onSnoozeClick(e.target, activePostId ?? "")}>
                  <i className={classnames("hand material-icons fz-13", { "text-danger": activePostSnooze })}>snooze</i>
                </li>

                <li className="list-inline-item  " title="เปิด/ปิด การติดธง">
                  {/* <button onClick={onOpenPostDetails} type="button" className="user-profile-show btn-cmd-wp"> */}
                  <i
                    className={classnames("hand fa-flag", { "far": !activePostFlag, "fas": activePostFlag, "text-danger": activePostFlag })}
                    onClick={() => onToggleFlag(activePostId ?? "")}
                  ></i>
                  {/* <i className="far fa-flag hand" onClick={() => alert('toggle flag')}></i> */}

                  {/* </button> */}
                </li>
                {/* change status */}
                <li className="list-inline-item " title={"สถานะ = " + Utils.GetWpStatus(activePostStatus)}>
                  <i className={classnames("", {
                    // "fa fa-file-o": activePostStatus === WpStatus.Open,
                    // "fa fa-file-zip-o": activePostStatus !== WpStatus.Open,
                    // "text-success": activePostStatus === WpStatus.Open,
                    // "text-danger": activePostStatus !== WpStatus.Open,
                    "fas fa-check-circle": activePostStatus !== WpStatus.Open,
                    "far fa-check-circle": activePostStatus === WpStatus.Open,
                    // "text-gray": activePostStatus === WpStatus.Open,
                    "text-danger": activePostStatus !== WpStatus.Open,
                    "hand": activePostCanChangeStatus,
                  })}
                    onClick={() => activePostCanChangeStatus ? onChangePostStatus(activePostId ?? "", activePostStatus === WpStatus.Open ? WpStatus.Close : WpStatus.Open) : null}
                  ></i>
                </li>

                <li className="list-inline-item " title="ข้อมูลโพส"><i className="fas fa-info-circle hand" onClick={() => onClickPostInfo()}></i></li>

                {/* delete post */}
                {activePostCanDel && (
                  <li className="list-inline-item " title="ลบโพส">
                    {isDeletingPost ? (<LoadingIconWithText loadingText={""}></LoadingIconWithText>) : (<i className="far fa-trash-alt hand text-danger" onClick={() => onDeletePost(activePostId ?? "")}></i>)}
                  </li>
                )}
              </ul>
            </div>
          </div>

          {/* Lower Row: Tag (Truncated) */}
          <div
            className="ps-2"
            style={{
              padding: 0,
              overflowX: "auto",  // Enable horizontal scroll
              overflowY: "hidden", // Prevent vertical scroll
              whiteSpace: "nowrap", // Ensure tags stay in one line
              textAlign: "left",
              scrollbarWidth: "none" // Hide scrollbar (Firefox)
            }}
          >
            {/* tag list */}
            <small>{activePostId == "" ? "เริ่มสร้างโพสใหม่ โดยการพิมพ์ในกล่องข้อความด้านล่าง" :
              <>
                {(activePostTags ?? []).map((tag: WpPostInfoTag, key: number) => (
                  <span key={key} className="wp-tag-at-header hand" onClick={() => onTagClick(tag.tagId ?? -1)} style={{ color: tag.faColor ?? "", backgroundColor: tag.bgColor ?? "" }}>
                    <span className={tag.faIcon ?? ""}></span>&nbsp;{tag.name ?? tag.tagId?.toString()}
                  </span>
                ))}
                &nbsp;
              </>
            }</small>
          </div>

        </div>
      </div >
    </>
  );
};

export default WorkplaceHead;
